import React, { useMemo } from "react";
import { Form, Input } from "antd";
import { validateEmailAddress } from "@/utils/utils";

const EmailInput = ({ formItemProps: _formItemProps, inputProps: _inputProps, required: _required }) => {
  const inputProps = useMemo(
    () => ({
      maxLength: 320,
      ..._inputProps,
    }),
    [_inputProps],
  );

  const formItemProps = useMemo(() => {
    const label = _formItemProps?.label || "Email";

    return {
      label,
      name: "email",
      rules: [
        {
          validator: (_, value) => {
            if (_required) {
              if (value && validateEmailAddress(value)) {
                return Promise.resolve();
              }

              if (!value) {
                return Promise.reject(`Please enter ${label}`);
              }

              return Promise.reject("Please enter a valid email");
            }
            return Promise.resolve();
          },
        },
      ],
      ..._formItemProps,
    };
  }, [_formItemProps, _required]);

  return (
    <Form.Item {...formItemProps}>
      <Input {...inputProps} style={{ borderRadius: 10, ...inputProps.style }} />
    </Form.Item>
  );
};

export default EmailInput;
